import type { TTagKind } from '@vlabs/uikit';

import { getSimilarityThresholds } from '@vlabs/shared/config/similarityThresholds';

export const calcTagType = (similarity: number): TTagKind => {
  const { low, medium } = getSimilarityThresholds();
  let tagType = 'positive';

  if (similarity < medium) tagType = 'attention';
  if (similarity < low) tagType = 'negative';
  return tagType;
};
